import "./style.css";
import { useState, useEffect } from "react";

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ThemeProvider, createTheme, Dialog } from "@mui/material";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import ScrollToTop from "../../Components/scrollup";
import ScrollPage from "../../Components/scrollpageUp";
import Carousel from "../../Components/Carousel";
import images1 from "../../Images/Banniere/opus.jpg";
import images3 from "../../Images/Banniere/realisations.jpg";
import image5 from "../../Images/Banniere/evolo.jpg";
import Image4 from "../../Images/Banniere/contact.jpg";
import image6 from "../../Images/Banniere/square.jpg";
import images7 from "../../Images/Banniere/square2.jpg";
import certif1 from "../../Images/certif1.jpg";
import certif2 from "../../Images/certif2.jpg";
import CountUp from "react-countup";
import ProductExample from "../../Components/ProductExample";
import tprLogo from "../../Images/partenaireLogo/logotpr.jpg";
import sovepLogo from "../../Images/partenaireLogo/logosovep.jpg";
import anime from "animejs";
import YouTubeScrollPlayer from "../../YoutubeAuto";

import Footer from "../../Components/Footer";
const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1080,
      lg: 1280,
    },
  },
  palette: {
    primary: {
      main: "#00897b",
      light: "#80cbc4",
      dark: "#00695c",
      contrastText: "#fff",
    },
  },
});
export default function Home() {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [open2, setOpen2] = React.useState(false);
  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.4 });
  const controls = useAnimation();
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
      setStartCount(true);
    }
  }, [isInView, controls]);

  const stats = [
    {
      label: "projets réalisés",
      value: 1000,
      suffix: "+",
      duration: 5,
      icon: "1",
    },
    {
      label: "Ans d’expérience",
      value: 17,
      suffix: "",
      duration: 5,
      icon: "2",
    },
    { label: "employés", value: 20, suffix: "+", duration: 5, icon: "3" },
    {
      label: "des clients satisfaits",
      value: 99,
      suffix: "%",
      duration: 4.5,
      icon: "4",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeInOut" },
    },
  };

  const images = [image6, images3, image5, images1, images7, Image4];
  const [isOpen, setIsOpen] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const ref1 = useRef(null);
  const isInView1 = useInView(ref1, { once: true });
  const ref3 = useRef(null);
  const isInView3 = useInView(ref3, { once: true });
  const ref4 = useRef(null);
  const isInView4 = useInView(ref4, { once: true });
  const ref5 = useRef(null);
  const isInView5 = useInView(ref5, { once: true });
  const ref6 = useRef(null);
  const isInView6 = useInView(ref6, { once: true });
  const ref7 = useRef(null);
  const isInView7 = useInView(ref7, { once: true });
  useEffect(() => {
    const updateItemsPerPage1 = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1200) {
        setItemsPerPage1(3);
      } else if (windowWidth >= 700) {
        setItemsPerPage1(3);
      } else {
        setItemsPerPage1(2);
      }
    };
    updateItemsPerPage1();
    window.addEventListener("resize", updateItemsPerPage1);

    return () => {
      window.removeEventListener("resize", updateItemsPerPage1);
    };
  }, []);
  const [itemsPerPage1, setItemsPerPage1] = useState(4);

  const settings2 = {
    slidesToShow: itemsPerPage1,
    autoplay: true,
    autoplaySpeed: 1200,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    className: "custom-slider",
  };
  useEffect(() => {
    anime({
      targets: ".refImgHome",
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(200, { start: 300 }),
      easing: "easeInOutQuad",
    });
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".refImgHome:not(.vide)");
    anime({
      targets: elements,
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(300, { start: 400 }),
      easing: "easeInOutQuad",
    });
  }, []);
  return (
    <ThemeProvider theme={customTheme}>
      <div className="home">
        <ScrollToTop />
        <ScrollPage />

        <div className="homeBack">
          <Carousel images={images} />
        </div>
        <div className="homeBody">
          <div className="homePresentation1">
            <div
              ref={ref1}
              style={{
                transform: isInView1 ? "none" : "translateX(200px)",
                opacity: isInView1 ? 1 : 0,
                transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
              }}
            >
              <h2>ELLOUZE ALU, l'aluminium conçu à la perfection :</h2>
              <p>
                Ellouze Alu est une référence en menuiserie aluminium haut de
                gamme, combinant plus de 17 ans d’expertise et d’innovation. <br/>
                Fondée en 2008 par Melek Ellouze et Rached Ellouze, l’entreprise
                conçoit et réalise des solutions sur mesure pour le résidentiel,
                le commercial et l’industriel : fenêtres, portes, façades,
                cloisons, murs rideaux, brise-soleil et bien plus encore.<br/> Chaque
                projet reflète notre engagement pour la qualité, le design et la
                durabilité, offrant des espaces élégants, fonctionnels et
                prestigieux.<br/> Faites confiance à une équipe passionnée et
                expérimentée pour transformer vos idées en réalisations
                concrètes et remarquables.
              </p>
            </div>
          </div>
          <motion.div
            ref={ref}
            initial="hidden"
            animate={controls}
            variants={containerVariants}
            className="statAnimation"
          >
            {stats.map((stat, index) => (
              <div key={index} className="statAnimationDetail">
                <div>
                  <img
                    src={require(`../../Images/icon/${stat.icon}.png`)}
                    alt={stat.icon}
                  />
                  {startCount ? (
                    <span className="statNumber">
                      <CountUp
                        end={stat.value}
                        duration={stat.duration}
                        suffix={stat.suffix}
                      />
                    </span>
                  ) : (
                    <span className="statNumber">0{stat.suffix}</span>
                  )}
                </div>
                <div className="statText">{stat.label}</div>
              </div>
            ))}
          </motion.div>
        </div>
        <YouTubeScrollPlayer />
        <div
          className="nosProduits"
          ref={ref7}
          style={{
            transform: isInView7 ? "none" : "translateX(200px)",
            opacity: isInView7 ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
          }}
        >
          <h2>nos réalisations</h2>
          <span></span>
          <div className="catHome">
            <Slider {...settings2}>
              {references.map((item) => (
                <div className={`images-zoom-container-home`}>
                  <a href={`${item.name}`}>
                    <img
                      src={require(`../../Images/realisation/${item.name}.jpg`)}
                      alt={item}
                      className="catImgHome"
                    />
                    <span className="catSpan">{item.name}</span>
                  </a>
                </div>
              ))}
            </Slider>
          </div>
        </div>

        <div
          className="nosProduits"
          ref={ref5}
          style={{
            transform: isInView5 ? "none" : "translateX(200px)",
            opacity: isInView5 ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
          }}
        >
          <h2>Nos Produits</h2>
          <span></span>
          <ProductExample />
        </div>

        <div
          className="nosProduits"
          ref={ref6}
          style={{
            transform: isInView6 ? "none" : "translateX(-200px)",
            opacity: isInView6 ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
          }}
        >
          <h2>Nos partenaires</h2>
          <span></span>
          <div className="frnsDiv">
            <div className="frnsDiv2">
              <img src={tprLogo} alt="tpr" className="frnsImg2" />
            </div>
            <div className="frnsDiv2">
              <img src={sovepLogo} alt="sovep" className="frnsImg2" />
            </div>
          </div>
        </div>
        <div
          className="nosProduits"
          ref={ref4}
          style={{
            transform: isInView4 ? "none" : "translateX(-200px)",
            opacity: isInView4 ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
          }}
        >
          <h2>Nos Clients</h2>
          <span></span>
          <div className="refGrid">
            {itemData.map((icon, index) => (
              <div key={index} className="referenceDiv">
                <div className="linkItems">
                  <div>
                    <img
                      src={require(`../../Images/ref/${icon}.png`)}
                      alt={icon}
                      className="refImgHome"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className="nosProduits"
          ref={ref3}
          style={{
            transform: isInView3 ? "none" : "translateX(-200px)",
            opacity: isInView3 ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
          }}
        >
          <h2>Nos Certificats</h2>
          <span></span>
          <div className="frnsDiv">
            <div className="frnsDiv2">
              <img
                src={certif1}
                alt="certif"
                className="certifImg"
                onClick={handleClickOpen}
              />
              <Dialog
                open={open}
                onClose={handleClose}
                onBackdropClick={handleClose}
                sx={{ zIndex: 9990888 }}
              >
                <img src={certif1} alt="tpr" className="certifImgDialog" />
              </Dialog>
            </div>
            <div className="frnsDiv2">
              <img
                src={certif2}
                alt="certif"
                className="certifImg"
                onClick={handleClickOpen2}
              />
              <Dialog
                open={open2}
                onClose={handleClose2}
                onBackdropClick={handleClose2}
                sx={{ zIndex: 9990888 }}
              >
                <img src={certif2} alt="tpr" className="certifImgDialog" />
              </Dialog>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </ThemeProvider>
  );
}
const itemData = [
  "logo1",
  "logo2",
  "logo3",
  "logo4",
  "logo5",
  "logo6",
  "logo7",
  "logo8",
];
const references = [
  {
    name: "waterfront",
    title: "waterfront Tunis",
  },
  {
    name: "square",
    title: "waterfront Tunis",
  },
  {
    name: "opus",
    title: "waterfront Tunis",
  },
  {
    name: "zen",
    title: "waterfront Tunis",
  },
  {
    name: "screen",
    title: "waterfront Tunis",
  },
  {
    name: "irix",
    title: "irix Tunis",
  },
  {
    name: "villa H",
    title: "Villa H",
  },
  {
    name: "villa M",
    title: "Villa M",
  },
  {
    name: "vital cube",
    title: "vital cube Tunis",
  },
  {
    name: "lighthouse",
    title: "lighthouse",
  },
  {
    name: "evolo",
    title: "evolo Tunis",
  },
];
